import { RuleValue } from "./RuleValue";

export class FormRule {
  name!: string;
  text!: string;
  field!: string;
  operator!: string;
  ruleValue!: RuleValue;
}
